/* cert/sagas*/
import {
  select,
  all,
  fork,
  put,
  takeEvery,
  takeLatest,
  spawn,
} from "redux-saga/effects";
import { has, isNil, includes, isEmpty } from "ramda";
import { Cert, CertActionTypes } from "./types";
import { fetch, save, drop } from "../../repo/cert";
import {
  fetchRequest,
  fetchError,
  fetchSuccess,
  saveRequest,
  saveSuccess,
  saveError,
  deleteRequest,
  deleteSuccess,
  deleteError,
} from "./actions";
import { dirty } from "../session/actions";
import { Error, isAuthError } from "../";

function* handleFetch(action: ReturnType<typeof fetchRequest>) {
  try {
    const cert = yield fetch(action.payload.id, action.payload.params);
    if (cert.errors && !isEmpty(cert.errors)) {
      if (isAuthError(cert.errors)) {
        yield put(dirty());
      }
      yield put(fetchError(JSON.stringify(cert.errors)));
    } else {
      yield put(fetchSuccess(cert));
    }
  } catch (err) {
    yield put(fetchError(err));
  }
}

function* watchFetchRequest() {
  yield takeEvery(CertActionTypes.FETCH, handleFetch);
}

function* handleSave(action: ReturnType<typeof saveRequest>) {
  try {
    const cert = yield save(action.payload.data, action.payload.query);
    // we may still have an error
    // if so then we should yield error
    if (cert.errors && !isEmpty(cert.errors)) {
      if (isAuthError(cert.errors)) {
        yield put(dirty());
      }
      yield put(saveError(JSON.stringify(cert.errors)));
      action.payload.callback &&
        action.payload.callback(JSON.stringify(cert.errors), null);
    } else {
      yield put(saveSuccess(cert));
      action.payload.callback && action.payload.callback(null, cert);
    }
  } catch (err) {
    yield put(saveError(err));
    action.payload.callback &&
      action.payload.callback("An error occurred while saving the Certificate", null);
  }
}

function* watchSaveRequest() {
  yield takeEvery(CertActionTypes.SAVE_REQUEST, handleSave);
}

function* handleDelete(action: ReturnType<typeof deleteRequest>) {
  try {
    const dropResponse = yield drop(action.payload.id);

    if (dropResponse.errors && !isEmpty(dropResponse.errors)) {
      if (isAuthError(dropResponse.errors)) {
        yield put(dirty());
      }
      yield put(deleteError(JSON.stringify(dropResponse.errors)));
      action.payload.callback &&
        action.payload.callback(JSON.stringify(dropResponse.errors));
    } else {
      yield put(deleteSuccess());
      action.payload.callback && action.payload.callback(null);
      yield put(fetchRequest(null));
    }
  } catch (err) {
    yield put(deleteError(err));
    action.payload.callback && action.payload.callback(JSON.stringify(err));
  }
}

function* watchDeleteRequest() {
  yield takeLatest(CertActionTypes.DELETE_REQUEST, handleDelete);
}

export default function* certSaga() {
  yield all([
    spawn(watchFetchRequest),
    spawn(watchSaveRequest),
    spawn(watchDeleteRequest),
  ]);
}
